"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.line_chart = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var line_chart = function line_chart(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'line-chart-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M3.5 4.5V15.5H16.5V4.5H3.5ZM3 3C2.44772 3 2 3.44772 2 4V16C2 16.5523 2.44772 17 3 17H17C17.5523 17 18 16.5523 18 16V4C18 3.44772 17.5523 3 17 3H3Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    d: 'M15.5 8.25C15.5 8.94036 14.9404 9.5 14.25 9.5C13.5596 9.5 13 8.94036 13 8.25C13 7.55964 13.5596 7 14.25 7C14.9404 7 15.5 7.55964 15.5 8.25Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    d: 'M12.1362 9.02279L9.75 11.409L7.78033 9.43934C7.48744 9.14645 7.01257 9.14645 6.71967 9.43934L4.21967 11.9393C3.92678 12.2322 3.92678 12.7071 4.21967 13C4.51256 13.2929 4.98744 13.2929 5.28033 13L7.25 11.0303L9.21967 13C9.51257 13.2929 9.98744 13.2929 10.2803 13L13.0975 10.1828C12.6575 9.91987 12.3147 9.51089 12.1362 9.02279Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    d: 'M13.0035 8.1555L13.2197 7.93934C13.5126 7.64645 13.9874 7.64645 14.2803 7.93934C14.5732 8.23223 14.5732 8.70711 14.2803 9L13.8468 9.43354C13.3543 9.2658 13 8.79927 13 8.25C13 8.21821 13.0012 8.18669 13.0035 8.1555Z',
    fill: '#4B5563'
  }));
};

exports.line_chart = line_chart;